<app-pcbread-crumb [data]="'warehouse,TransferBetweenStock'"></app-pcbread-crumb>
<div class="card p-2 animate__animated animate__backInDown">

    <app-pctable-action [data]="action" [header]="fields" (parentAction)="parentAction($event)">
    </app-pctable-action>

    <div class="row pb-2 m-0">
        <div class="col-12">
            <label>{{ 'sourceStocks' | translate}}</label>
            <select class="form-select" data-allow-clear="true" (change)="getSingleData()" [(ngModel)]="sourceStockSelected">
                <option *ngFor="let stock of stockList" [ngValue]="stock.id">
                    {{stock.persianName}}
                </option>
            </select>
        </div>
    </div>

    <app-pctable [data]="data" [entityField]="fields" (parentAction)="parentAction($event)" class="have-max-height">
    </app-pctable>

    <app-pcpaging [paging]="paging" (parentAction)="parentAction($event)">
    </app-pcpaging>

    <app-loading-panel *ngIf="loading">
    </app-loading-panel>

</div>

<app-pcsuccess-modal [showModal]="modalSuccessConfirm" (parentAction)="parentAction($event)">
</app-pcsuccess-modal>

<app-warehouse-handling-modal [modalIsOpen]="modalWarehouseIsOpen" [data]="thisItemOnStock" (parentActionOutput)="parentAction($event)">
</app-warehouse-handling-modal>
